import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-fonts-config',
  templateUrl: 'fonts-config.component.html'
})
export class FontsConfigComponent implements OnInit {
  @Input() item: any;
  @Input() layout: number;
  @Input() customData: any;
  @Output() public sendEvent = new EventEmitter<any>();

  constructor(
  ) {
  }

  ngOnInit() {
    
  }

  emitSendEvent() {
    this.sendEvent.emit();
  }

  getPhoto($event: any): void {
    this.item.favicon = $event.path;
  }

}
